/**
 * When extending the control panel, be sure to uncomment the necessary code for your build process:
 * https://statamic.dev/extending/control-panel
 */

import $ from "jquery";

$("#filter-insight input").on("click", function () {
    const thisVal = $(this).val();
    if (thisVal == "date:asc") {
        $(".insight-asc").removeClass("d-none");
        $(".insight-desc").addClass("d-none");
    } else {
        $(".insight-desc").removeClass("d-none");
        $(".insight-asc").addClass("d-none");
    }
});

$("#filter-insight-category input").on("click", function () {
    const thisCategoryVal = $(this).val();
    console.log(thisCategoryVal);
    if (thisCategoryVal == "all") {
        $(".item-list").removeClass("d-none");
    } else {
        $(".item-list").addClass("d-none");
        $(".category-" + thisCategoryVal + "").removeClass("d-none");
    }
});

$("#filter-insight-mobile input").on("click", function () {
    const thisVal = $(this).val();
    if (thisVal == "date:asc") {
        $(".insight-asc").removeClass("d-none");
        $(".insight-desc").addClass("d-none");
    } else {
        $(".insight-desc").removeClass("d-none");
        $(".insight-asc").addClass("d-none");
    }
});

$("#filter-insight-category-mobile input").on("click", function () {
    const thisCategoryVal = $(this).val();
    console.log(thisCategoryVal);
    if (thisCategoryVal == "all") {
        $(".item-list").removeClass("d-none");
    } else {
        $(".item-list").addClass("d-none");
        $(".category-" + thisCategoryVal + "").removeClass("d-none");
    }
});

// Mobile

$(".filter-mobile .button-apply").on("click", function () {
    $("#filter-mobile").removeClass("show-filter");
    $("body").css("overflow", "");
});
